import { setLocalStorageItem } from 'libs/utils/localStorage';
import { ItemAfterUploadActions } from 'constants/item';
import { SAVED_ITEM_STORAGE_KEY, PUSHED_ITEM_STORAGE_KEY, FEEDBACK_ITEM_ID } from 'constants/storage';
export function setNewItemIdToStorage(response) {
  var _response$after_uploa;

  if ('errors' in response) return;
  if (!('item' in response)) return;
  if (!response.item.id) return;
  const itemId = response.item.id.toString();
  const showOfflineVerificationModal = (_response$after_uploa = response.after_upload_actions) === null || _response$after_uploa === void 0 ? void 0 : _response$after_uploa.includes(ItemAfterUploadActions.ShowOfflineVerificationModal);
  if (showOfflineVerificationModal) return;
  setLocalStorageItem(SAVED_ITEM_STORAGE_KEY, itemId);
}
export function setFeedbackItemIdToStorage(response) {
  var _response$after_uploa2;

  if ('errors' in response) return;
  if ((_response$after_uploa2 = response.after_upload_actions) !== null && _response$after_uploa2 !== void 0 && _response$after_uploa2.includes(ItemAfterUploadActions.ShowOfflineVerificationModal)) return;

  if ('item' in response && response.item.id) {
    setLocalStorageItem(FEEDBACK_ITEM_ID, response.item.id.toString());
    return;
  }

  if ('draft' in response && response.draft.id) {
    setLocalStorageItem(FEEDBACK_ITEM_ID, response.draft.id.toString());
  }
}
export function setPushedItemIdToStorage(response) {
  if ('errors' in response) return;

  if ('item' in response && response.item.id) {
    setLocalStorageItem(PUSHED_ITEM_STORAGE_KEY, response.item.id.toString());
    return;
  }

  if ('draft' in response && response.draft.id) {
    setLocalStorageItem(PUSHED_ITEM_STORAGE_KEY, response.draft.id.toString());
  }
}
export const getSupportedAttributesArray = supportedDynamicAttributes => Object.keys(supportedDynamicAttributes).filter(attr => supportedDynamicAttributes[attr]).map(attr => attr);